import SEOLandingTemplate from './SEOLandingTemplate';

export default function PageSpeedCheckerPage() {
  return (
    <SEOLandingTemplate
      title="Page Speed Checker"
      metaTitle="Free Page Speed Checker | Sungresh"
      metaDescription="Check your website's load time and Core Web Vitals, with a prioritized list of specific fixes to speed up your site."
      h1="Free Page Speed Checker"
      sub="Test any URL for load time and Core Web Vitals (LCP, CLS, and related metrics), with specific, prioritized fixes rather than just a raw score."
      keywords="page speed checker, website speed test, core web vitals checker"
      ctaLink="/audit/site"
      ctaText="Check Speed Free"
      features={[
        { icon: '⚡', title: 'Speed Score', desc: 'An overall 0-100 performance score' },
        { icon: '📊', title: 'Core Web Vitals', desc: 'Key loading and stability metrics Google tracks' },
        { icon: '⏱️', title: 'Load Time', desc: 'Full page load time' },
        { icon: '🖼️', title: 'Specific Issues', desc: 'Flags things like unoptimized images or render-blocking scripts' },
      ]}
      faqs={[
        { q: 'What counts as a good speed score?', a: 'Generally, 90+ is considered good, 50-89 needs improvement, and below 50 is poor — but the specific Core Web Vitals thresholds (like Largest Contentful Paint under 2.5 seconds) matter more than the single overall number.' },
        { q: 'What usually has the biggest impact on speed?', a: 'Unoptimized images are the most common culprit, followed by unminified JavaScript/CSS and a lack of browser caching. Fixing images alone often produces the largest single improvement.' },
        { q: 'Does page speed actually affect SEO?', a: 'Yes — Core Web Vitals are a confirmed ranking factor, though a relatively modest one among many. Speed matters more directly for user experience and conversion rate; a slow page loses visitors regardless of where it ranks.' },
      ]}
    />
  );
}
